import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { logout, setAccountBlocked } from "../features/auth/authSlice";
import { LogOut } from "../services/api";
import { LogoutUser } from "../services/Firebase";

export default function AccountBlockedModal() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleOkay = async () => {
    try {
      await LogOut();
    } catch (err) {
      console.log("Backend LogOut failed:", err);
    }
    
    try {
      await LogoutUser();
    } catch (err) {
      console.log("Firebase Logout failed:", err);
    }
    
    dispatch(logout());
    dispatch(setAccountBlocked(false));
    navigate("/");
  };

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/80 px-4">
      <div className="bg-[#1a1a1a] p-8 rounded-2xl w-full max-w-sm text-center border border-gray-800 shadow-2xl">
        <h2 className="text-2xl font-bold text-red-500 mb-4">Account Blocked</h2>
        <p className="text-gray-300 text-base mb-8">
          Your account has been blocked. Please contact support if you believe this is a mistake.
        </p>

        <button
          onClick={handleOkay}
          className="w-full bg-red-500 hover:bg-red-500 text-white font-bold py-3 px-4 rounded-full transition-colors"
        >
          Okay
        </button>
      </div>
    </div>
  );
}
